import { IsString, MinLength } from 'class-validator';

export class DeactivateTenantDto {
  @IsString()
  @MinLength(1)
  confirmationWord!: string;
}
